import { CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { QuestionCategoryFormValues } from "src/models/QuestionCategory.model";
import { useEditQuestionCategoryMutation, useGetQuestionCategoryByIdQuery } from "src/services/QuestionCategoryServices";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import JobForm from "../Layout/QuestionCategoryForm";

type Props = {
  onClose: () => void;
  categoryId: string;
};

const EditQuestionCategoryFormWrapper = ({ onClose, categoryId }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);
  const [questionCategoryData, setQuestionCategory] = useState<any>({});

  const [editQuestionCategory] = useEditQuestionCategoryMutation();
  const { data, isLoading, isFetching } = useGetQuestionCategoryByIdQuery({
    id: categoryId,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setQuestionCategory(data?.data);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: QuestionCategoryFormValues = {
    category: questionCategoryData?.categoryName || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    category: string().required("Please enter category"),
  });

  // Handle Submit
  const handleSubmit = (
    values: QuestionCategoryFormValues,
    { setSubmitting, resetForm }: FormikHelpers<QuestionCategoryFormValues>
  ) => {
    const formatedValue = {
      categoryName: values.category,
    };
    editQuestionCategory({
      body: formatedValue,
      id: categoryId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <JobForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Edit"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditQuestionCategoryFormWrapper;
